import { MultiWidgetTabItem } from "../models"

export const vouchersTab: MultiWidgetTabItem = {
    key: "VOUCHERS",
    text: "{{31}}",
    sort: 5,
}
